import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { LoaderService } from './../services/loader.service';
import { AuthService } from './auth.service';


@Injectable()
export class BaseService {

  constructor(private authService: AuthService, private loadService: LoaderService, private http: HttpClient, private route: Router)
    {
    }

    get(url, options?: any) {

        this.loadService.showProgressBar();

        if (!options)
            options = {};
        options.headers = this.getCustomHeaders();

        return this.http.get(url, options)
            .map((res: any) => { return this.handleResponse(res); })
            .catch(err => { return this.handleError(err) })
            .finally(() => {
                this.loadService.hideProgressBar();
            });
    }

    post(url, postBody: any, options?: any) {
        this.loadService.showSpinner();

        if (!options)
            options = {};
        options.headers = this.getCustomHeaders();

        return this.http.post(url, postBody, options)
            .map((res: any) => { return this.handleResponse(res); })
            .catch(err => { return this.handleError(err) })
            .finally(() => {
                this.loadService.hideSpinner();
            });
    }

    put(url, postBody: any, options?: any) {
        this.loadService.showSpinner();

        if (!options)
            options = {};
        options.headers = this.getCustomHeaders();

        return this.http.put(url, postBody, options)
            .map((res: any) => { return this.handleResponse(res); })
            .catch(err => { return this.handleError(err) })
            .finally(() => {
                this.loadService.hideSpinner();
            });
  }

    delete(url, options?: any) {
        this.loadService.showSpinner();

        if (!options)
            options = {};
        options.headers = this.getCustomHeaders();

        return this.http.delete(url, options)
            .map((res: any) => { return this.handleResponse(res); })
            .catch(err => { return this.handleError(err) })
            .finally(() => {
                this.loadService.hideSpinner();
            });
    }
    
    handleResponse(res: any): any {
        return res;
    }

    handleError(error: HttpErrorResponse): Observable<any> {
        if (error.status == 401) {
            this.authService.logout().subscribe(
                success => { return null; },
                err => { return Observable.throw(error); }
            );
        }
        else {
            console.log(error);
            return Observable.throw(error);
        }
    }

    getToken(): any {
        return this.authService.getToken();
    }

    setToken(token: string): void {
        this.authService.setToken(token);
    }

    private getCustomHeaders(): HttpHeaders {
      if (this.authService.getIdImpianto() != null)
        return new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'bearer ' + this.authService.getToken(), 'idImpianto': this.authService.getIdImpianto() });
      return new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'bearer ' + this.authService.getToken()});
    }
}



// WEBPACK FOOTER //
// ./src/app/services/base.service.ts